import React from 'react'
import { motion } from 'framer-motion' // Import Motion
import Digital from '../../assets/first.jpg';
import Lang from '../../assets/connection.jpg'
import Strategy from '../../assets/strategy.jpg';
import Tools from '../../assets/mech.jpg';
import { FaDownload } from 'react-icons/fa';

const Phylosophy = () => {
    // Parent container animation logic
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Delay between each card
                duration: 2 // Total section fade duration
            }
        }
    };

    // Individual item animation logic
    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { 
            opacity: 1, 
            y: 0, 
            transition: { duration: 2, ease: "easeOut" } // 2 second duration as requested
        }
    };

    return (
        <section className="toolkit">
            <motion.div 
                className="container h"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
                variants={containerVariants}
            >
                <motion.h2 className="h2-dark center" variants={itemVariants}>
                    The Blueprint of Excellence
                </motion.h2>
                <div className="divider">
                    <div className="v-primary vider"></div>
                    <div className="v-dark vider"></div>
                    <div className="v-primary vider"></div>
                </div>
                <div className="wrapper shadow">
                    <div className="description">
                        
                        <div className="cards">
                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={Digital} alt='Digital design' className='card-image'/>
                                </div>
                                <h3 className="card-head-dark">
                                    Safety First: 
                                </h3>
                                <div className="description">
                                    <p className="card-text-dark">
                                        I strictly adhere to professional standards, including Lockout/Tagout (LOTO) and 
                                        Occupational Health and Safety (OHS). By prioritising a secure environment, 
                                        I ensure that every technical installation—whether electrical or mechanical—is 
                                        executed with maximum precision, protecting both the equipment and the people on-site.
                                    </p>
                                </div>
                            </motion.div>

                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={Tools} alt='Technical engineering' className='card-image'/>
                                </div>
                                <h3 className="card-head-dark">
                                    Adaptability: 
                                </h3>
                                <div className="description">
                                    <p className="card-text-dark">
                                        My transition from Assistant Plumber at Plumbing Solutions Ltd to a Web Developer 
                                        reflects my ability to master new systems quickly. I thrive in evolving environments, 
                                        leveraging my diverse technical background to solve complex problems and integrate 
                                        new technologies efficiently across different professional domains and industries.
                                    </p>
                                </div>
                            </motion.div>

                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={Strategy} alt='Digital design' className='card-image'/>
                                </div>
                                <h3 className="card-head-dark">
                                    Strategic Collaboration: 
                                </h3>
                                <div className="description">
                                    <p className="card-text-dark">
                                        I leverage a proactive mindset to streamline workflows and enhance team productivity through 
                                        meticulous planning and clear organisation. By combining my technical expertise with a 
                                        solution-oriented approach, I ensure that project goals are met with high standards of quality, 
                                        efficiency, and professional integrity.
                                    </p>
                                </div>
                            </motion.div>

                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={Lang} alt='Digital design' className='card-image'/>
                                </div>
                                <h3 className="card-head-dark">
                                    Connection: 
                                </h3>
                                <div className="description">
                                    <p className="card-text-dark">
                                        I bridge communication gaps through fluency in English, French, Swahili, and Lingala. 
                                        This multilingual capability allows me to collaborate effectively with diverse teams and 
                                        clients, ensuring that technical requirements are understood and that project objectives 
                                        are clearly communicated across various cultural and linguistic boundaries.
                                    </p>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </motion.div>
            <div className="space"></div>
            <div className="btns-center">
                <button className="btn secondary">
                    Download My Full Resume {''} <FaDownload className='setting'/>
                </button>
            </div>
        </section>
    )
}

export default Phylosophy